import { render, staticRenderFns } from "./introuduce-list.vue?vue&type=template&id=722a3bb3&scoped=true&"
import script from "./introuduce-list.vue?vue&type=script&lang=ts&"
export * from "./introuduce-list.vue?vue&type=script&lang=ts&"
import style0 from "./introuduce-list.vue?vue&type=style&index=0&id=722a3bb3&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "722a3bb3",
  null
  
)

export default component.exports